import $ from '@vaersaagod/tools/Dom';
import Viewport from '@vaersaagod/tools/Viewport';
import Dispatch from '@vaersaagod/tools/Dispatch';
import * as Events from '../lib/events';

export default el => {
    const dom = $(el);
    const slides = dom.find('[data-slide]');
    const duration = 1.5;
    const slideLength = 3000;
    const total = slides.length;
    const arrow = dom.find('[data-scroll-anchor-link]');
    const logowrap = dom.find('[data-logo-wrap]');
    let timeout;
    let listening = false;
    let currentSlide = slides.eq(0);
    let nextSlide = slides.eq(1);
    let currentIndex = 0;
    let nextIndex = 1;
    let nextNextIndex = total > 2 ? 2 : 0;
    let nextNextSlide = slides.eq(nextNextIndex);
    let prevSlide = [];
    let counter = 0;

    const update = () => {
        console.log('update', currentIndex, nextIndex, nextNextIndex);
        prevSlide = currentSlide;
        currentSlide = nextSlide;
        currentIndex = nextIndex;
        nextIndex = currentIndex < (total - 1) ? currentIndex + 1 : 0;
        nextNextIndex = nextIndex < (total - 1) ? nextIndex + 1 : 0;
        nextSlide = slides.eq(nextIndex);
        nextNextSlide = slides.eq(nextNextIndex);
        console.log('updated', currentIndex, nextIndex, nextNextIndex);
    };

    const animate = () => {
        console.log('animate');
        const tl = new TimelineMax();
        const temp = nextNextSlide.clone().addClass('foobar');

        tl.call(() => { dom.append(temp); }, 0)
            .set(temp.get(0), { clearProps: 'all' }, 0)
            .set(temp.get(0), { xPercent: 100, display: 'block', zIndex: 7 }, 0)
            .set(temp.find('[data-image]').get(0), { xPercent: -90 }, 0)
            .set(temp.find('[data-text]').get(0), { opacity: 0 }, 0);

        tl.set(nextNextSlide.get(0), { xPercent: 100, zIndex: 8, display: 'block' }, duration)
            .set(nextNextSlide.find('[data-image]').get(0), { xPercent: -90 }, duration)
            .set(nextNextSlide.find('[data-text]').get(0), { opacity: 0 }, duration)
            .call(() => { temp.remove(); }, null, null, duration);


        if (prevSlide.length && total > 3) {
            tl.set(prevSlide.get(0), { zIndex: 5 }, duration);
        }

        tl.set(nextSlide.get(0), { xPercent: 100, display: 'block', zIndex: 9 }, 0)
            .set(nextSlide.find('[data-image]').get(0), { xPercent: -90 }, 0)
            .set(nextSlide.find('[data-text]').get(0), { xPercent: 2, opacity: 0 }, 0)
            .set(currentSlide.get(0), { zIndex: 8 }, 0)
            .to(currentSlide.get(0), duration, { xPercent: -20, ease: 'Quint.easeInOut' }, 0)
            .to(currentSlide.find('[data-text]').get(0), duration, { xPercent: -75, opacity: 0, ease: 'Quint.easeInOut' }, 0)
            .to(currentSlide.find('[data-image]').get(0), duration, { xPercent: 0.8 * 20, ease: 'Quint.easeInOut' }, 0)
            .to(nextSlide.find('[data-image]').get(0), duration, { xPercent: 0, ease: 'Quint.easeInOut' }, 0)
            .to(nextSlide.find('[data-text]').get(0), duration * 2, { xPercent: 0, opacity: 1, ease: 'Quint.easeOut' }, duration / 1.5)
            .to(nextSlide.get(0), duration, { xPercent: 0, ease: 'Quint.easeInOut' }, 0)
            .set(currentSlide.get(0), { zIndex: 7 }, duration);

        if (nextSlide.data('slide') === 'white') {
            arrow.removeClass('c-dark').addClass('c-white');
        } else {
            arrow.removeClass('c-white').addClass('c-dark');
        }

        Dispatch.emit(Events.HERO_SLIDE, { textColor: nextSlide.data('slide') });
        update();
        timeout = setTimeout(checkPosition, slideLength);
    };

    const hasFocus = () => {
        if (typeof document.hasFocus === 'function') {
            return document.hasFocus();
        }
        return true;
    };

    const updateCounter = () => {
        counter += 1;
        if (counter === slides.length) {
            counter = 0;
        }
    };

    const fade = () => {
        const current = slides.get(counter);
        updateCounter();
        const next = slides.get(counter);

        const tl = new TimelineMax()
            .set(next, { opacity: 0, zIndex: 99 }, 0)
            .set(next, { scale: 1.05 })
            .set(current, { zIndex: 98 }, 0)
            .call(() => {
                $(next).addClass('u-wc-o', 'u-wc-t');
            }, null, null, 0)
            .to(next, duration * 0.7, { opacity: 1, ease: 'Quint.easeInOut' }, 0)
            .to(next, duration * 2, { scale: 1, ease: 'Quint.easeOut' }, 0)
            .call(() => {
                $(next).removeClass('u-wc-o', 'u-wc-t');
            })
            .set(current, { clearProps: 'all' })
            .call(() => {
                timeout = setTimeout(checkPosition, slideLength);
            });
    };

    const checkPosition = () => {
        if (Viewport.visible(el)) {
            if (listening || !hasFocus()) {
                listening = false;
                Viewport.off('scroll', checkPosition);
                clearTimeout(timeout);
                timeout = setTimeout(checkPosition, slideLength);
            } else {
                fade();
                // animate();
            }
        } else if (!listening) {
            listening = true;
            Viewport.on('scroll', checkPosition);
        }
    };

    const initSlides = () => {
        TweenMax.set(slides.get(1), { xPercent: 100, display: 'block' });
        TweenMax.set(slides.eq(1).find('[data-image]').get(0), { xPercent: -90 });
        TweenMax.set(slides.eq(1).find('[data-text]').get(0), { opacity: 0 });

        if (slides.length > 2) {
            TweenMax.set(slides.get(2), { xPercent: -20, display: 'block' });
            TweenMax.set(slides.eq(2).find('[data-image]').get(0), { xPercent: 0.8 * 20 });
            TweenMax.set(slides.eq(2).find('[data-text]').get(0), { opacity: 0 });
        }
    };

    const init = () => {
        if (Viewport.width >= 750) {
            TweenMax.set(logowrap.get(0), { y: 40 });
            TweenMax.to(logowrap.get(0), 0.9, { delay: 0.85, opacity: 1, y: 0, ease: 'Quad.easeOut' });
        } else {
            TweenMax.set(logowrap.get(0), { opacity: 1 });
        }

        if (total === 0) {
            dom.addClass('d-n');
            $('body').addClass('has-dark-header pt-200');
            return;
        }

        dom.find('.lazyload').addClass('lazypreload');
        if (currentSlide.data('slide') === 'white') {
            arrow.addClass('c-white');
        }
        if (total > 1) {
            // initSlides();
            timeout = setTimeout(checkPosition, slideLength);
        }

        Dispatch.emit(Events.HERO_SLIDE, { textColor: currentSlide.data('slide') });
    };

    const destroy = () => {
        Viewport.off('scroll', checkPosition);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/FrontHero.js